module.exports = __webpack_public_path__ + "img/Medioambiente.a8c70778.svg";